export default __webpack_public_path__ + "static/media/fbIcon.fdcb277d.svg";